function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M21.192 11.717H2.808A.796.796 0 002 12.5c0 .433.362.783.808.783h18.384c.446 0 .808-.35.808-.783a.796.796 0 00-.808-.783z"
}), React.createElement("path", {
  d: "M3.95 12.5l6.323-6.131a.767.767 0 000-1.108.826.826 0 00-1.142 0l-6.894 6.685a.767.767 0 000 1.108l6.894 6.685c.157.153.364.23.571.23a.818.818 0 00.571-.23.767.767 0 000-1.108L3.95 12.5z"
}));

var SvgIcDetailsEditBack = function SvgIcDetailsEditBack(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "53ab9a8bc8c074d618772fa1a6bb3c55.svg";
export { SvgIcDetailsEditBack as ReactComponent };